(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-live-dvr"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-live-dvr"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-live-dvr.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-live-dvr.js":
/*!*************************************!*\
  !*** ./src/mggp-plugin-live-dvr.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class MggpPluginLiveDvr
 */
var MggpPluginLiveDvr = function (_Plugin) {
  _inherits(MggpPluginLiveDvr, _Plugin);

  function MggpPluginLiveDvr() {
    var _ref;

    _classCallCheck(this, MggpPluginLiveDvr);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = MggpPluginLiveDvr.__proto__ || Object.getPrototypeOf(MggpPluginLiveDvr)).call.apply(_ref, [this].concat(args)));

    _this._reset = function () {
      if (!_this._skipReset) {
        _this._skipReset = false;
        _this._started = false;
        _this._paused = false;
        _this._info = null;
        _this._epgTimeInfo = null;
        _this._timeOffset = 0;
        _this._epgTimeOffset = 0;
        _this._isMPD = false;

        _this._lastPlayerState = -1;
        _this._pausedPosition = 0;
        _this.player.set('liveDvr:position', 0);
        _this.player.set('liveDvr:duration', 0);
        _this.player.set('liveDvr:time', 0);
        _this.player.set('liveDvr:isTimeshift', false);
      }
      _this._skipReset = false;
    };

    _this.dispose = function () {
      _this._reset();
      _this._toggleListeners(false);
    };

    _this.load = function (pSrc, pVideoInfo) {
      if (!_this._started && pVideoInfo.live_start && pVideoInfo.content_type.indexOf('live') !== -1) {
        _this._info = pVideoInfo;
        _this._info.content_type = 'live_dvr';
        _this._isMPD = _this._info.src.includes('.mpd');
        _this._loadEpgTime();
        _this._toggleListeners(true);
        _this._started = true;
      }
    };

    _this._loadEpgTime = function () {
      var data = void 0;
      if (_this.player.getEpgTime) {
        _this.player.getEpgTime(function (response) {
          try {
            data = JSON.parse(response);
            _this._parseEpgTime(data);
          } catch (error) {}
        });
      } else {
        if (_this._info && _this._info.is_embed) {
          window.fetch(_this.config.epgTimeUrl || '/aprxev3/epg/time').then(function (response) {
            return response.json();
          }).then(function (response) {
            if (response.result === 'ok') {
              _this._parseEpgTime(response.data);
            }
          });
        }
      }
    };

    _this._parseEpgTime = function (pData) {
      _this._epgTimeInfo = pData;
      var offset = parseInt(Date.now() / 1000 - _this._epgTimeInfo.timestamp);
      _this._epgTimeOffset = offset;
    };

    _this._toggleListeners = function (add) {

      if (add) {
        _this.player.on('player:timeUpdate', _this._onTimeUpdate);
        _this.player.on('property:videoInfo', _this._onVideoInfo);
        _this.player.on('property:state', _this._onStateChange);
        _this.player.on('liveDvr:seek', _this._seek);
        _this.player.on('liveDvr:backOnAir', _this._backOnAir);
        _this.player.on('player:stop', _this._reset);
      } else {
        _this.player.off('player:timeUpdate', _this._onTimeUpdate);
        _this.player.off('property:videoInfo', _this._onVideoInfo);
        _this.player.off('property:state', _this._onStateChange);
        _this.player.off('liveDvr:seek', _this._seek);
        _this.player.off('liveDvr:backOnAir', _this._backOnAir);
        _this.player.off('player:stop', _this._reset);
      }
    };

    _this._getLiveTime = function (liveStart, epgTimeOffset) {
      var time = Math.floor(new Date().getTime() / 1000) + epgTimeOffset;
      return time - liveStart;
    };

    _this._onVideoInfo = function (pInfo) {
      var info = pInfo.data;
      if (info && _this._started) {
        if (_this._info && _this._info.video_id === info.video_id) {
          if (info.content_type === 'live') info.content_type = "tv_dvr";
        } else {
          _this._reset();
          _this._toggleListeners(false);
        }
      }
    };

    _this._onTimeUpdate = function () {
      if (!_this._started) return;
      var liveTime = _this._getLiveTime(_this._info.live_start, _this._epgTimeOffset);
      var position = _this._timeOffset > 0 ? liveTime - _this._timeOffset : liveTime;
      var duration = _this._info.live_stop - _this._info.live_start;

      if (_this.player.get('state') === 5) return;

      _this.player.set('liveDvr:duration', duration);
      _this.player.set('liveDvr:position', (_this._paused ? _this._pausedPosition : position) - _this._epgTimeOffset);
      _this.player.set('liveDvr:time', liveTime - _this._epgTimeOffset);
    };

    _this._onStateChange = function (pEvent) {
      /*if(this._isMPD && pEvent.data === 1 && !this._epgTimeOffset) {
        this._epgTimeOffset = Date.now()/1000 - this.player.getPlayableElement().currentTime;
      }*/

      if (_this._lastPlayerState === 1 && pEvent.data === 2) {
        _this._paused = true;
        _this.player.set('liveDvr:isTimeshift', true);
        _this._pausedPosition = parseInt(_this.player.get('liveDvr:position'));
      }
      if (_this._paused && pEvent.data === 1) {
        _this._paused = false;
        _this._seek({ data: _this._pausedPosition }, false, true);
      }

      _this._lastPlayerState = pEvent.data;
    };

    _this._seek = function (pEvent) {
      var backOnAir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var seekAfterPause = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var position = _this.player.get('liveDvr:position');
      var time = _this.player.get('liveDvr:time');
      var offset = Math.max(time - parseInt(pEvent.data), 0);
      var liveTime = _this._getLiveTime(_this._info.live_start, _this._epgTimeOffset);

      _this._timeOffset = backOnAir ? 0 : offset; // time in live

      if (seekAfterPause && _this._isMPD && !backOnAir) {
        _this.player.getPlayableElement().currentTime += 0; //flush buffer
        _this.player.set('liveDvr:isTimeshift', _this._timeOffset !== 0);
        return;
      }

      if (position === time && _this._timeOffset === 0) {
        // not call load playlist after seek
        return;
      }

      if (_this._paused) {
        _this._pausedPosition = liveTime - _this._timeOffset;
      }

      _this._skipReset = true;
      _this._onTimeUpdate(); // force position calculation after seek

      var targetUrl = _this._info.src;

      if (_this._isMPD) {
        if (!backOnAir) {
          var video = _this.player.getPlayableElement();

          if (video) video.currentTime = _this._timeOffset > 0 ? _this._info.live_start + pEvent.data : _this._info.live_start + liveTime;
          _this.player.set('liveDvr:isTimeshift', _this._timeOffset !== 0);
          return;
        }
      } else if (_this._timeOffset > 0) {
        if (targetUrl.includes('type.live')) {
          targetUrl = targetUrl.replace('type.live', 'ts/' + _this._timeOffset + '/type.live');
        } else {
          var lastSlashIndex = targetUrl.lastIndexOf('/');
          if (lastSlashIndex !== -1) {
            targetUrl = targetUrl.slice(0, lastSlashIndex) + ('/ts/' + _this._timeOffset) + targetUrl.slice(lastSlashIndex);
          }
        }
      }

      // this code for dvr seek came from mggp-plugin-dvr
      // here I left original comment below
      var options = _this.player.config.checkDefaultOptions(_this._info);
      options.autoplay = !_this._paused;

      _this._info = Object.assign({}, _this._info);
      _this.player.stop();

      // somewhere in loader called player.stop(), after calling player.load below.
      // Those .stop() resets props in player. This leads that src become null on re-load()'s after plugin-audio
      window.setTimeout(function () {
        _this.player.load(targetUrl, _this._info, options);
      }, 0);
      _this.player.set('liveDvr:isTimeshift', _this._timeOffset !== 0);
    };

    _this._backOnAir = function () {
      _this._seek({ data: 0 }, true);
    };

    _this.player.registerProperty('liveDvr:position', 0, true);
    _this.player.registerProperty('liveDvr:duration', 0, true);
    _this.player.registerProperty('liveDvr:time', 0, true);
    _this.player.registerProperty('liveDvr:isTimeshift', false, true);

    _this._reset();
    return _this;
  }

  return MggpPluginLiveDvr;
}(_mggpPlayer.Plugin);

exports.default = MggpPluginLiveDvr;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});